import i18nLanguages, { LocaleData } from "@cospired/i18n-iso-languages";
import de from "@cospired/i18n-iso-languages/langs/de.json";
import en from "@cospired/i18n-iso-languages/langs/en.json";

i18nLanguages.registerLocale(de as LocaleData);
i18nLanguages.registerLocale(en as LocaleData);
